import { handleScroll, subMenu } from './front/header';
import { initMap } from './front/google-maps';
import { handlePopup } from './front/popup';
import { initializeScrollHandler } from './front/sections-scroll';

document.addEventListener( 'DOMContentLoaded', () => {

	subMenu();
	handlePopup();

} );

// initMap();
window.initMap = initMap;
handleScroll();
initializeScrollHandler();

import { ButtonIframe } from './front/components/ButtonIframe'
ButtonIframe()

import { smileSnapButtonsHandle } from './front/components/smileSnapButtons'
smileSnapButtonsHandle()
